import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayOfYear from 'dayjs/plugin/dayOfYear';
import 'dayjs/locale/de';

dayjs.locale('de');
dayjs.extend(relativeTime);
dayjs.extend(dayOfYear);

const h01 = 3600;
const h06 = 21600;
const h24 = 86400;

class LastUpdated {
  /**
   * @param {Object} element
   * @param {Number} [datetime]
   */
  constructor(element, datetime) {
    let compare;
    if (!datetime) {
      compare = Math.floor(Date.now() / 1000);
    } else {
      compare = datetime;
    }

    let timestamp;
    if (element.dataset.date) {
      timestamp = Math.floor(Date.parse(element.dataset.date) / 1000);
    } else if (element.dataset.tstamp) {
      timestamp = element.dataset.tstamp;
    } else {
      return;
    }

    const text = this.convert(timestamp, compare);
    if (text) {
      // eslint-disable-next-line no-param-reassign
      element.innerText = text;
    }
  }

  /**
   * @param {Number} timestamp
   * @param {Number} compare
   * @return {String}
   */
  // eslint-disable-next-line class-methods-use-this
  convert(timestamp, compare) {
    const diff = compare - timestamp;

    if (diff > h24) {
      return '';
    }

    if (diff > h06) {
      // Today or yesterday?
      const prefix = dayjs.unix(compare)
        .dayOfYear() === dayjs.unix(timestamp)
        .dayOfYear() ? 'Heute, ' : 'Gestern, ';

      // dayjs(.localizedFormat) seems to NOT be capable of displaying localized suffix "Uhr" in
      // analogy to AM/PM
      return `${prefix + dayjs.unix(timestamp).format('H:mm')} Uhr`;
    }

    // Every timespan smaller than 6h hours can be handled with dayjs.relativeTime
    return dayjs.unix(timestamp)
      .from(dayjs.unix(compare));
  }
}

export { h01, h06, h24 };
export default LastUpdated;
